import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../../../store/store';
import { JWTHeader } from '../../../utils/JWTHeader';
import Badge from '../Badge';
import { showToast } from '../Notification/ToastrNotif.module';

const WarningValidationPending: React.FC = () => {
  const [pendingCount, setPendingCount] = useState<number>(0);
  const company = useSelector((state: RootState) => state.auth.company);
  const jwt = useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    const fetchPendingValidations = async() => {
      if (!company || !jwt || !company.id) {return;}

      try {
        const response = await fetch(`/api/companies/${company.id}/copros/validation-pending/count`, JWTHeader(jwt));

        if (!response.ok) {
          showToast('error', 'Une erreur est survenue lors du chargement des données.');
          throw new Error('Failed to fetch pending validations');
        }

        const data = await response.json();
        setPendingCount(data.pending);
      } catch (error) {
        showToast('error', 'Une erreur est survenue lors du chargement des données.');
        console.error('Error fetching pending validations :', error);
      }
    };

    fetchPendingValidations();
  }, [company, jwt]);

  if (pendingCount > 0) {
    return (
      <div className="flex w-full place-content-center">
        <Badge
          className="mb-6 pl-12"
          dismissible
          mode="warning"
          text={(
            <span>
              Certaines de vos copropriétés sont toujours en cours de validation par l'administrateur. Les fonctionnalités qui leur sont associées sont désactivées jusqu'à validation.
            </span>
          )}
        />
      </div>
    );
  }

  return null;
};

export default WarningValidationPending;
